import React from 'react';
import { createRoot } from 'react-dom/client'; // Update import
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AllAuthProviders } from './providers/Auth/AllAuthProviders';
import ErrorBoundary from './ErrorBoundary';
import ErrorPage from './error';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary name="app" fallback={<ErrorPage />}>
      <HelmetProvider>
        <Router>
          <AllAuthProviders>
            <App />
          </AllAuthProviders>
        </Router>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
